import { render } from "./AppointmentsList.vue?vue&type=template&id=3f31b3ae&scoped=true&ts=true"
import script from "./AppointmentsList.vue?vue&type=script&lang=ts"
export * from "./AppointmentsList.vue?vue&type=script&lang=ts"

import "./AppointmentsList.vue?vue&type=style&index=0&id=3f31b3ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f31b3ae"]])

export default __exports__